"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonQuotedColumnParser = void 0;
const ColumnFormatter_1 = require("./ColumnFormatter");
const Token_1 = require("../Token");
class NonQuotedColumnParser {
  parserOptions;
  columnFormatter;
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    this.columnFormatter = new ColumnFormatter_1.ColumnFormatter(parserOptions);
  }
  parse(scanner) {
    if (!scanner.hasMoreCharacters) {
      return null;
    }
    const {
      parserOptions
    } = this;
    const characters = [];
    let nextToken = scanner.nextCharacterToken;
    for (; nextToken; nextToken = scanner.nextCharacterToken) {
      if (Token_1.Token.isTokenDelimiter(nextToken, parserOptions) || Token_1.Token.isTokenRowDelimiter(nextToken)) {
        break;
      }
      characters.push(nextToken.token);
      scanner.advancePastToken(nextToken);
    }
    return this.columnFormatter.format(characters.join(''));
  }
}
exports.NonQuotedColumnParser = NonQuotedColumnParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb2x1bW5Gb3JtYXR0ZXJfMSIsInJlcXVpcmUiLCJUb2tlbl8xIiwiTm9uUXVvdGVkQ29sdW1uUGFyc2VyIiwicGFyc2VyT3B0aW9ucyIsImNvbHVtbkZvcm1hdHRlciIsImNvbnN0cnVjdG9yIiwiQ29sdW1uRm9ybWF0dGVyIiwicGFyc2UiLCJzY2FubmVyIiwiaGFzTW9yZUNoYXJhY3RlcnMiLCJjaGFyYWN0ZXJzIiwibmV4dFRva2VuIiwibmV4dENoYXJhY3RlclRva2VuIiwiVG9rZW4iLCJpc1Rva2VuRGVsaW1pdGVyIiwiaXNUb2tlblJvd0RlbGltaXRlciIsInB1c2giLCJ0b2tlbiIsImFkdmFuY2VQYXN0VG9rZW4iLCJmb3JtYXQiLCJqb2luIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL05vblF1b3RlZENvbHVtblBhcnNlci50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0EsTUFBQUEsaUJBQUEsR0FBQUMsT0FBQTtBQUVBLE1BQUFDLE9BQUEsR0FBQUQsT0FBQTtBQUVBLE1BQWFFLHFCQUFxQjtFQUNiQyxhQUFhO0VBRWJDLGVBQWU7RUFFaENDLFlBQW1CRixhQUE0QjtJQUMzQyxJQUFJLENBQUNBLGFBQWEsR0FBR0EsYUFBYTtJQUNsQyxJQUFJLENBQUNDLGVBQWUsR0FBRyxJQUFJTCxpQkFBQSxDQUFBTyxlQUFlLENBQUNILGFBQWEsQ0FBQztFQUM3RDtFQUVPSSxLQUFLQSxDQUFDQyxPQUFnQjtJQUN6QixJQUFJLENBQUNBLE9BQU8sQ0FBQ0MsaUJBQWlCLEVBQUU7TUFDNUIsT0FBTyxJQUFJO0lBQ2Y7SUFDQSxNQUFNO01BQUVOO0lBQWEsQ0FBRSxHQUFHLElBQUk7SUFDOUIsTUFBTU8sVUFBVSxHQUFHLEVBQUU7SUFDckIsSUFBSUMsU0FBUyxHQUFHSCxPQUFPLENBQUNJLGtCQUFrQjtJQUMxQyxPQUFPRCxTQUFTLEVBQUVBLFNBQVMsR0FBR0gsT0FBTyxDQUFDSSxrQkFBa0IsRUFBRTtNQUN0RCxJQUFJWCxPQUFBLENBQUFZLEtBQUssQ0FBQ0MsZ0JBQWdCLENBQUNILFNBQVMsRUFBRVIsYUFBYSxDQUFDLElBQUlGLE9BQUEsQ0FBQVksS0FBSyxDQUFDRSxtQkFBbUIsQ0FBQ0osU0FBUyxDQUFDLEVBQUU7UUFDMUY7TUFDSjtNQUNBRCxVQUFVLENBQUNNLElBQUksQ0FBQ0wsU0FBUyxDQUFDTSxLQUFLLENBQUM7TUFDaENULE9BQU8sQ0FBQ1UsZ0JBQWdCLENBQUNQLFNBQVMsQ0FBQztJQUN2QztJQUNBLE9BQU8sSUFBSSxDQUFDUCxlQUFlLENBQUNlLE1BQU0sQ0FBQ1QsVUFBVSxDQUFDVSxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7RUFDM0Q7O0FBekJKQyxPQUFBLENBQUFuQixxQkFBQSxHQUFBQSxxQkFBQSIsImlnbm9yZUxpc3QiOltdfQ==